// @flow
import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';
import type { HistoryDateRangeType } from '../domain/HistoryDateRange';

const BORDER_RADIUS = 3;

const Table = styled.table`
  border-spacing: 0px;
  width: 100%;
  table-layout: fixed;

  td:first-child {
    border-radius: ${BORDER_RADIUS}px 0px 0px ${BORDER_RADIUS}px;
  }

  td:last-child {
    border-radius: 0px ${BORDER_RADIUS}px ${BORDER_RADIUS}px 0px;
  }

  td:not(:first-child) {
    border-left: none;
  }

  .selected {
    background-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.tertiaryText};
  }
`;

const DateRangeOption = styled.td`
  border: 1px solid ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  padding: ${({ theme }) => theme.metrics.margin}px;
  text-align: center;
  cursor: pointer;
`;

type Props = {
  dateRanges: HistoryDateRangeType[];
  selectedDateRange: HistoryDateRangeType;
  onSelectDateRange: (range: HistoryDateRangeType) => void;

  t: any;
}

function HistoryDateRangeSelector(props: Props) {
  const { t, dateRanges, selectedDateRange, onSelectDateRange } = props;

  return (
    <Table>
      <tbody>
        <tr>
          {Array.from(dateRanges).map((dateRange) => {
            return (
              <DateRangeOption
                key={dateRange}
                onClick={() => onSelectDateRange(dateRange)}
                className={dateRange === selectedDateRange ? 'selected' : ''}
              >
                {t(dateRange)}
              </DateRangeOption>
            );
          })
          }
        </tr>
      </tbody>
    </Table>
  );
}

export default translate('history')(HistoryDateRangeSelector);



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/components/HistoryDateRangeSelector.js